import axios from 'axios';
import Cookies from "js-cookie";
import config from '../config/config';

const userAgent = navigator.userAgent;

//-- It's common function for using the token
const withToken = (apiName, data) => {
    // Initialize the i18n translation hook.
    const loginData = (!Cookies.get('loginSuccessMrMintAdmin')) ? [] : JSON.parse(Cookies.get('loginSuccessMrMintAdmin'));
  
    let token = loginData?.authToken;
    // Create a new AbortController instance
    const controller = new AbortController();
    const signal = controller.signal;

    // Define an abort function to cancel the request
    const abort = () => controller.abort();

    // Create a promise that resolves when the request is completed
    const requestPromise = axios({
        method: 'POST',
        url: `${config.apiUrl + apiName}`,
        headers: { 'Content-Type': 'application/json', 'Authorization': `${token}`, 'browserType': userAgent },
        data: data,
        signal: signal, // Associate the signal with the request
    }).then((handleResponse) => {
        return handleResponse;
    }).catch(error => {
        if (error && error.response && error.response.data && !error.response.data.status) {
            // toast.error(
            //     t('errorMsg'), {
            //     position: toast.POSITION.TOP_RIGHT,
            // })
        }
    });

    // Attach the abort function to the promise so you can cancel the request if needed
    requestPromise.abort = abort;

    return requestPromise;
}


const getWithToken = async (apiName,data) => {
    try {
        // Fetch login data from cookies
        const loginData = Cookies.get("loginSuccessStepMrMint")
            ? JSON.parse(Cookies.get("loginSuccessStepMrMint"))
            : null;

        // Extract the token
        const token = loginData?.authToken;

        if (!token) {
            throw new Error("Authorization token is missing.");
        }

        // Make the API call
        const response = await axios({
            method: "GET",
            url: `${config.serverPath + apiName}`,
            params: data,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                version: "website"
            },
        });

        // Handle response (implement `handleResponse` if necessary)
        return handleResponse(response);
    } catch (error) {
        // Log the error for debugging
        console.error("API call failed:", error);

        // Display error to the user
        if (error.response?.data?.status === false) {
            // toast.error("An error occurred while fetching data.", {
            //     position: toast.POSITION.TOP_RIGHT,
            // });
        } else {
            // toast.error(error.message || "An unknown error occurred.", {
            //     position: toast.POSITION.TOP_RIGHT,
            // });
        }

        throw error;
    }
};

const getWithOutToken = async (apiName,data) => {
    try {
        // Make the API call
        const response = await axios({
            method: "GET",
            url: `${config.serverPath + apiName}`,
            params: data,
            headers: {
                "Content-Type": "application/json",
                version: "website"
            },
        });

        // Handle response (implement `handleResponse` if necessary)
        return handleResponse(response);
    } catch (error) {
        // Log the error for debugging
        console.error("API call failed:", error);

        // Display error to the user
        if (error.response?.data?.status === false) {
            // toast.error("An error occurred while fetching data.", {
            //     position: toast.POSITION.TOP_RIGHT,
            // });
        } else {
            // toast.error(error.message || "An unknown error occurred.", {
            //     position: toast.POSITION.TOP_RIGHT,
            // });
        }

        throw error;
    }
};

// Function to handle API responses
function handleResponse(response) {
    if (response.status === 200 || response.status === 201) {
        return response.data; // Return only the data for easier usage
    } else {
        const error = response;
        return Promise.reject(error);
    }
}


export const commonService = {
    withToken,
    getWithToken,
    getWithOutToken
};